import { render } from "./DefaultProjectCard.vue?vue&type=template&id=1de0ba02"
import script from "./DefaultProjectCard.vue?vue&type=script&lang=js"
export * from "./DefaultProjectCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__